import React from "react";

type TrendTableProps = {
  trendsCurveRawData: {
    tNo: number;
    Trend: string;
    data: { month: string; contribution: number }[];
  }[];
};

const TrendTable: React.FC<TrendTableProps> = ({ trendsCurveRawData }) => {
  return (
    <div className="pt-4 m-4 font-poppins">
      <div className="overflow-x-auto">
        <div className="min-w-full border border-gray-300 text-center rounded-md">
          {/* Table Header */}
          <div
            className="grid border-b border-gray-300 text-center bg-gray-100 font-bold text-gray-800"
            style={{
              display: "grid",
              gridTemplateColumns: `60px 150px repeat(${trendsCurveRawData[0]?.data.length || 0}, minmax(60px, 1fr))`,
            }}
          >
            <div className="p-2 border-r border-gray-300 text-center">
              Trend No.
            </div>
            <div className="p-2 border-r border-gray-300 text-center">
              Trend
            </div>
            {trendsCurveRawData[0]?.data
              .slice()
              .reverse()
              .map((item, index) => (
                <div
                  key={index}
                  className="p-2 border-r border-gray-300 text-center"
                >
                  {item.month.split(",")[0] +
                    " " +
                    (Number(item.month.split(",")[1]) % 100)}
                </div>
              ))}
          </div>

          {/* Table Body */}
          {trendsCurveRawData.map((row, index) => (
            <div
              key={index}
              className="grid border-b border-gray-300"
              style={{
                display: "grid",
                gridTemplateColumns: `60px 150px repeat(${trendsCurveRawData[0]?.data.length || 0}, minmax(60px, 1fr))`,
              }}
            >
              <div className="p-2 border-r border-gray-300">{row.tNo}</div>
              <div className="p-2 border-r border-gray-300">{row.Trend}</div>
              {row.data
                .slice()
                .reverse()
                .map((item, idx) => (
                  <div key={idx} className="p-2 border-r border-gray-300">
                    {item.contribution}
                  </div>
                ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrendTable;
